var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "shortcuts-container" }, [
    _c("div", { staticClass: "shortcuts-section" }, [
      _c("div", { staticClass: "section-header" }, [
        _c("div", { staticClass: "os-header" }, [
          _c("i", { staticClass: "fa-brands fa-windows" }),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.windows")))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "divider" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("CTRL")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("M")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.openPrivateChat")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("ESC")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.escKey")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("CTRL")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("K")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("search.searchAreaTitle")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("F1")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.focusInput")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("F4")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.previousOpenedChat")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("TAB")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.showSystemStatus")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("CTRL")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v(",")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.copilot_desc_num")) +
              "\n            "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "shortcuts-section" }, [
      _c("div", { staticClass: "section-header" }, [
        _c("div", { staticClass: "os-header" }, [
          _c("i", { staticClass: "fa-brands fa-apple" }),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.macOS")))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "divider" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [
              _vm._v("Command"),
            ]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("M")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.openPrivateChat")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("ESC")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.escKey")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [
              _vm._v("Command"),
            ]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("K")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("search.searchAreaTitle")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("F1")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.focusInput")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("F4")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.previousOpenedChat")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("TAB")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.showSystemStatus")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [
              _vm._v("Command"),
            ]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v(",")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.copilot_desc_num")) +
              "\n            "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "shortcuts-section" }, [
      _c("div", { staticClass: "section-header" }, [
        _c("div", { staticClass: "os-header" }, [
          _c("i", { staticClass: "far fa-comment-dots" }),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.chatShortcuts")))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "divider" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c(
              "b-badge",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      content: _vm.$t("message.examplePm"),
                      placement: "top",
                      theme: "light-border",
                    },
                    expression:
                      "{\n                        content: $t('message.examplePm'),\n                        placement: 'top',\n                        theme: 'light-border'\n                    }",
                  },
                ],
                attrs: { variant: "success" },
              },
              [_vm._v("pm:")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.pmDescription")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c(
              "b-badge",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      content: _vm.$t("message.exampleName"),
                      placement: "top",
                      theme: "light-border",
                    },
                    expression:
                      "{\n                        content: $t('message.exampleName'),\n                        placement: 'top',\n                        theme: 'light-border'\n                    }",
                  },
                ],
                attrs: { variant: "success" },
              },
              [_vm._v("@name")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.nameDescription")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c(
              "b-badge",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      content: _vm.$t("message.exampleEmail"),
                      placement: "top",
                      theme: "light-border",
                    },
                    expression:
                      "{\n                        content: $t('message.exampleEmail'),\n                        placement: 'top',\n                        theme: 'light-border'\n                    }",
                  },
                ],
                attrs: { variant: "success" },
              },
              [_vm._v("@email")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.descriptionEmail")) +
              "\n            "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "shortcuts-section" }, [
      _c("div", { staticClass: "section-header" }, [
        _c("div", { staticClass: "os-header" }, [
          _c("i", { staticClass: "far fa-window-maximize" }),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.chatWindow")))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "divider" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("W")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.endConversation")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("F")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.redirectConversation")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("P")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.sendPrivateMessage")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("B")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.blockUser")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("T")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.createTask")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("O")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.showProfile")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [_c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("C")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.markAsAnswered")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("1")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.switchToChatLayout")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("2")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.switchToTableLayout")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut-item" }, [
        _c(
          "div",
          { staticClass: "shortcut-keys" },
          [
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("Ctrl")]),
            _vm._v("\n                +\n                "),
            _c("b-badge", { attrs: { variant: "primary" } }, [_vm._v("3")]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shortcut-description" }, [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("message.switchToKanbanLayout")) +
              "\n            "
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }